import l from "lodash/isDate";
import o from "lodash/isString";
import { arrayHasItems as u, pageForDate as i, getMaxPage as h, datesAreEqual as m, addPages as f } from "../helpers.js";
class p {
  constructor({ format: e, parse: t }) {
    Object.assign(this, { format: e, parse: t });
  }
  hasValue(e) {
    return u(e);
  }
  formatValue(e) {
    return this.hasValue(e) ? e.map((t) => this.format(t)).join(", ") : "";
  }
  parseValue(e) {
    return o(e) ? e.split(",").map((t) => this.parse(t)).filter((t) => l(t)) : [];
  }
  normalize(e) {
    return this.hasValue(e) ? [...new Set(e)].sort((t, r) => t.getTime() - r.getTime()) : [];
  }
  filterDisabled({ value: e, isRequired: t, disabled: r, fallbackValue: s }) {
    if (!this.hasValue(e))
      return [];
    if (!r)
      return e;
    const a = e.filter((n) => !r.intersectsDate(n));
    return !this.hasValue(a) && t ? s : a;
  }
  valuesAreEqual(e, t) {
    const r = this.hasValue(e), s = this.hasValue(t);
    return !r && !s ? !0 : r !== s || e.length !== t.length ? !1 : e.some((a) => !t.includes(a));
  }
  getPageRange(e) {
    if (!this.hasValue(e))
      return null;
    const t = i(e[0]), r = h(i([].concat(e).pop()), f(t, 1));
    return { from: t, to: r };
  }
  handleDayClick(e, t) {
    if (!t.dateIsValid(e.date))
      return;
    let r = [];
    this.hasValue(t.model) ? t.model.some((s) => s.getTime() === e.dateTime) ? (r = t.model.filter((s) => !m(s, e.date)), !this.hasValue(r) && t.isRequired && (r = [e.date])) : r = [...t.model, e.date] : r = [e.date], t.model = this.normalize(r);
  }
  handleDayMouseEnter() {
  }
}
export {
  p as default
};
//# sourceMappingURL=multiple.js.map
